import { useLocation, useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const pathname = location.pathname;
  const isAdminSubtab =
    pathname.startsWith("/admin") && !/^\/admin\/?$/.test(pathname);

  const handleBack = () => {
    navigate("/admin");
  };

  if (!isAdminSubtab) {
    return null;
  }

  return (
    <div className="global-back-wrap">
      <button
        type="button"
        className="global-back-button"
        onClick={handleBack}
      >
        Back to Dashboard
      </button>
    </div>
  );
};

export default BackButton;
